// tslint:disable
// this is an auto generated file. This will be overwritten

export const createShow = `mutation CreateShow($input: CreateShowInput!) {
  createShow(input: $input) {
    id
    username
    timeStart
    timeEnd
    platform
  }
}
`;
export const updateShow = `mutation UpdateShow($input: UpdateShowInput!) {
  updateShow(input: $input) {
    id
    username
    timeStart
    timeEnd
    platform
  }
}
`;
export const deleteShow = `mutation DeleteShow($input: DeleteShowInput!) {
  deleteShow(input: $input) {
    id
    username
    timeStart
    timeEnd
    platform
  }
}
`;
